import { Injectable } from '@angular/core';

import { Size } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SizeService extends TmsWebBaseEditService<Size, Size> {
  constructor() {
    super('Size', $localize`Size`);
  }
}
